<aside class="zf-rail" [class.collapsed]="!expanded()" (mouseleave)="onLeaveRail()">

  <a class="zf-brand" routerLink="/" title="Home">
    <span class="zf-brand-mark">
      @if (logoUrl()) {
        <img [src]="logoUrl()" alt="Logo" class="zf-brand-client" />
      } @else {
        <img src="images/zenflow-mark.png" alt="Zenflow" />
      }
    </span>
    <span class="zf-brand-text">
      <span class="zf-brand-name">ZENFLOW</span>
      <span class="zf-brand-sub">AI ERP</span>
    </span>
  </a>

  <nav class="zf-nav">
    @for (g of groups(); track g.id) {
      <div class="zf-group" (mouseenter)="onEnterGroup(g.id, $event)">
        <div class="zf-group-btn"
             [class.active]="isActiveGroup(g.id)"
             [class.open]="expanded() && openGroup() === g.id"
             (click)="onClickGroup(g.id, $event)">
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke-width="1.6"
               stroke-linecap="round" stroke-linejoin="round">
            <path [attr.d]="iconPath(g.icon)"></path>
          </svg>
          <span class="zf-group-label">{{ g.label }}</span>
          <svg class="zf-caret" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"></path></svg>
        </div>

        <!-- Expanded rail: inline accordion -->
        @if (expanded() && openGroup() === g.id) {
          <div class="zf-inline">
            @for (cat of g.categories; track cat.id) {
              @if (g.categories.length > 1) {
                <div class="zf-section">{{ cat.label }}</div>
              }
              @for (item of cat.items; track item.label) {
                <a class="zf-leaf"
                   [routerLink]="item.route" [queryParams]="item.queryParams"
                   [class.active]="isActiveItem(item)">{{ item.label }}</a>
              }
            }
          </div>
        }
      </div>
    }
  </nav>

  <div class="zf-rail-foot">
    <div class="zf-rail-toggle" (click)="toggle()" [title]="expanded() ? 'Collapse menu' : 'Expand menu'">
      <span class="zf-glyph">{{ expanded() ? '⇤' : '⇥' }}</span>
      <span>Collapse menu</span>
    </div>
  </div>
</aside>

<!-- Collapsed rail: hover flyout -->
@if (!expanded() && flyout(); as f) {
  <div class="zf-flyout" [style.left.px]="railWidth()" [style.top.px]="f.top"
       (mouseenter)="holdFlyout()" (mouseleave)="onLeaveRail()">
    <div class="zf-flyout-card" [style.max-height.px]="f.maxHeight">
      <div class="zf-flyout-title">{{ f.group.label | uppercase }}</div>
      @for (cat of f.group.categories; track cat.id) {
        @if (f.group.categories.length > 1) {
          <div class="zf-section">{{ cat.label }}</div>
        }
        @for (item of cat.items; track item.label) {
          <a class="zf-leaf" [class.indent]="f.group.categories.length > 1"
             [routerLink]="item.route" [queryParams]="item.queryParams"
             [class.active]="isActiveItem(item)" (click)="closeFlyout()">{{ item.label }}</a>
        }
      }
    </div>
  </div>
}
